import { Component, OnInit} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';

import { EventGroup } from '@finder/features/calendars/calendars.interface';
import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { CalendarsService } from '@finder/features/calendars/services/calendar.service';

@Component({
    selector: 'finder-view-all',
    templateUrl: './view-all.component.html',
    styleUrls: ['./view-all.component.scss']
})
export class ViewAllModalComponent implements ModalChildComponent, OnInit {

    date: string;
    events: EventGroup;
    title: string;
    parentComponent: ModalComponent;
    showLinks: boolean;

    private destroy$ = new Subject<void>();

    constructor(
        private calendarService: CalendarsService,
    ) { }

    ngOnInit() {
        this.showLinks = this.calendarService.allowLinksOnPage();
        this.calendarService.watchViewAll()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                const { events, date, title } = data;
                this.events = events;
                this.date = date;
                this.title = title;
            });
    }
}
